<template>
    <div id="page-login" class="auth-form d-flex flex-column h-100">
        <nav-header></nav-header>
        <div class="container d-inline-flex flex-fill">
            
            <div
                id="recaptchaContainer"
                data-size="invisible"
                />
            <div v-if="page == 'phone'" class="login-content text-center m-lg-auto">
                <div class="row">
                    <div class="col-lg-6 p-lg-5 d-lg-flex">
                        <div class="w-100 m-auto">
                            <h3 class="d-lg-none">{{ $t('login.auth_phone_title') }}</h3>
                            <video src="/video/mts/auth-phone.mp4" type="video/mp4" class="video-phone" muted autoplay loop playsinline>
                                Your browser does not support the video.
                            </video>
                            <img src="/images/logo.png" class="d-none d-lg-inline" alt="AdBalu"/>
                            <p class="text-primary mt-lg-3">{{ $t('login.auth_phone_text') }}</p>
                        </div>
                    </div>
                    <div class="col-lg-6 p-lg-5">
                        
                        <h1 class="d-none d-lg-block">{{ $t('login.auth_phone_title') }}</h1>
                        <form @submit.prevent="onPhoneSubmit" class="p-0 p-lg-3">
                            <div id="recaptcha-container"></div>
                            <div class="text-center mb-3">{{ $t('login.auth_phone_inputs_phone') }}</div>
                            <div class="form-group row mb-lg-5">
                                <b-dropdown class="col-5" variant="default">
                                    <template v-if="country != null" v-slot:button-content>
                                      <img :src="country.icon" height="15"/> {{ country.text }}
                                    </template>
                                    <b-dropdown-item v-for="c in countries" @click="country = c;btnSfx();" :key="c.value"><img :src="c.icon" height="15"/> {{ c.text }}</b-dropdown-item>
                                </b-dropdown>
                                <div class="col-7 pl-0"> 
                                    <b-form-input v-model="phone" type="number" autofocus></b-form-input>
                                </div>
                            </div>
                            <p>{{ $t('login.auth_phone_inputs_referral_top') }}</p>
                            <div class="form-group">
                                <b-form-input v-model="referral" size="lg" type="text" class="green-b text-center mb-2" autocomplete="off"></b-form-input>
                                <p v-if="registrationReferralRequired" class="text-primary">{{ $t('login.auth_phone_inputs_referral_bottom_required') }}</p>
                                <p v-else class="text-primary">{{ $t('login.auth_phone_inputs_referral_bottom') }}</p>
                            </div>
                            <hr/>
                            <div class="form-check">
                                <label class="checkContainer text-left orange mb-1 mt-1">
                                    <p v-html="$t('login.auth_phone_privacy_text')"></p>
                                    <input type="checkbox" v-model="privacyConfirm" id="exampleCheck1"/>
                                    <span class="checkmark"></span>
                                </label>
                            </div>

                            <div class="w-100 pt-3"> 
                                <b-button type="submit" variant="primary" size="lg" @click="btnSfx" class="pl-5 pr-5" >{{ $t('login.auth_phone_btn_next') }}</b-button>
                            </div>
                        </form>

                    </div>
                </div>
                
            </div>
            <div v-if="page == 'code'" class="login-content text-center m-lg-auto">
                <div class="row">
                    <div class="col-lg-6 p-lg-5 d-lg-flex flex-column">
                        <div class="w-100 m-auto">
                            <h3 class="d-lg-none">{{ $t('login.auth_code_title') }}</h3>
                            <video src="/video/mts/auth-code.mp4" type="video/mp4" class="video-code" muted autoplay loop playsinline>
                                Your browser does not support the video.
                            </video>
                            <img src="/images/logo.png" class="d-none d-lg-inline" alt="AdBalu"/>
                            <p class="text-primary d-none d-lg-block mt-lg-3">{{ $t('login.auth_phone_text') }}</p>
                        </div>
                    </div>
                    <div class="col-lg-6 p-lg-5 d-lg-flex flex-column">
                        <h1 class="d-none d-lg-block">{{ $t('login.auth_code_title') }}</h1>
                        <form @submit.prevent="onCodeSubmit" class="p-3 p-lg-4 m-auto w-100">
                            <div class="text-center mb-4">{{ $t('login.auth_code_label_phone') }}</div>
                            <div class="form-group mb-5">
                                <b-form-input v-model="code" type="number" size="lg" class="text-center" autofocus></b-form-input>
                            </div>
                            <div class="form-group pt-4">
                                <a class="text-primary" href="#" @click.prevent="onPhoneSubmit();btnSfx();">{{ $t('login.auth_code_btn_resend') }}</a>
                            </div>
                            <div class="form-group">
                                <b-button type="submit" variant="primary" size="lg" @click="btnSfx">{{ $t('login.auth_code_btn_next') }}</b-button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <footer-text></footer-text>
    </div>
</template>
<script>
import app from '../app'
import api from '../api'
import Header from '../components/Header.vue' 
import Footer from '../components/Footer.vue'

import firebase from "firebase/app";
import "firebase/auth";

export default {
    data () {
        return {
            page: 'phone',
            code: '',
            phone: '',
            room: '',
            message: '',
            referral: '',
            country: null,
            privacyConfirm: false,
            countries: [{icon: "/images/icon-sr.png", text: "+381", value: "+381"}],

            registrationReferralRequired: true,

            recaptcha: false,
        }
    },

    computed: {
        primaryAuthenticationFlow(){
            return this.$store.state.config.data.primaryAuthenticationFlow ?? "firebase";
        }
    },

    mounted() {
        const $this = this;
        this.country = this.countries[0];

        document.body.classList.add('theme-auth');
        // set reCAPTCHA
        if (this.primaryAuthenticationFlow === 'otp-sms'){
            if (typeof grecaptcha === "undefined") {
                var script = document.createElement("script");
                script.src = "https://www.google.com/recaptcha/api.js?render=explicit";
                document.head.appendChild(script);
                setTimeout(() => $this.renderCaptcha(), 1000);
            }
        }
        else {
            // Start Firebase invisible reCAPTCHA verifier
            window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
                size: 'invisible',
                callback: () => {
                // reCAPTCHA solved, allow signInWithPhoneNumber.
                },
            });

            window.recaptchaVerifier.render().then((widgetId) => {
                window.recaptchaWidgetId = widgetId;
            });
        }

        this.$store.dispatch('sound/bg','BG_Home');
    },
    methods: {

        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },

        onPhoneSubmit() {
            if(this.country == null || this.phone.trim() == "")
                return;

            if(!this.privacyConfirm){
                this.$store.dispatch('sound/sfx','Error');
                this.$bvModal.msgBoxOk(this.$t('login.privacy_singin_error_text'), {
                    title: this.$t('login.privacy_singin_error_title'),
                    size: 'sm',
                    buttonSize: 'lg',
                    okTitle: this.$t('base.btn_ok'),
                    modalClass: 'confirmModal',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    this.$store.dispatch('sound/sfx','Button');
                });
                return;
            }

            const $this = this;
            let loader = document.getElementById('loader');
            loader.classList.add("show");

            api.referralValidation(this.country.value + this.phone, this.referral)
                .then(function (response) {
                    $this.otpLogin();
                })
                .catch(function (error) {
                    api.baseErrorHendler(error);
                })
                .then(function () {
                    loader.classList.remove("show");
                });
        },

        otpLogin(){
            const $this = this;

            this.$bvModal.msgBoxConfirm(this.$t('login.phone_singin_confirm_text', { phone: this.country.value + this.phone }), {
                title: this.$t('login.phone_singin_confirm_title'),
                size: 'sm',
                buttonSize: 'lg',
                okTitle: this.$t('base.btn_ok'),
                cancelTitle: this.$t('base.btn_cancel'),
                modalClass: 'confirmModal',
                hideHeaderClose: false,
                centered: true,
            })
            .then(value => {
                if(value){
                    if(this.primaryAuthenticationFlow === "otp-sms"){
                        $this.executeCaptcha();
                    }
                    else {
                        firebase.auth().signInWithPhoneNumber(this.country.value + this.phone, window.recaptchaVerifier)
                            .then(function (confirmationResult) {
                                window.confirmationResult = confirmationResult;
                                $this.page = "code";
                            }).catch(function (error) {
                                $this.errorMessage();
                            });
                    }
                }
            })
            .then(value => {
                $this.$store.dispatch('sound/sfx','Button');
            });
        
        },

        smsOtpLogin(token){
            const $this = this;
            api.otpSms(this.country.value + this.phone, token).then(res => {
                $this.page = "code";
            })
            .catch(err => {
                $this.errorMessage();
            });
        },

        async onCodeSubmit(){
            if(this.code == null || this.code.trim() == "")
                return;

            const $this = this;
            let loader = document.getElementById('loader');
            loader.classList.add("show");

            try {
                if (this.primaryAuthenticationFlow === 'otp-sms'){
                    this.login('otp_sms', this.code.trim());
                }
                else {
                    let result = await window.confirmationResult.confirm(this.code);
                    // User signed in successfully.
                    let token = await result.user.getIdToken();
                    this.login('msisdn', token);
                }
            }
            catch(error){
                $this.$store.dispatch('sound/sfx','Error');
                $this.$bvModal.msgBoxOk($this.$t('login.phone_singin_error_text'), {
                    title: $this.$t('login.phone_singin_error_title'),
                    size: 'sm',
                    buttonSize: 'lg',
                    okTitle: $this.$t('base.btn_ok'),
                    modalClass: 'confirmModal',
                    hideHeaderClose: false,
                    centered: true
                }).then(value => {
                    $this.$store.dispatch('sound/sfx','Button');
                });
            }

            loader.classList.remove("show");
        },

        login(grant_type, token){
            const $this = this;
            this.$store.dispatch('auth/login', { grant_type, msisdn: `${this.country.value}${this.phone}`, otp: token, referralUsername: this.referral }).then((user) => {
                if (user.state == "UNREGISTERED") $this.$router.push({ name: 'register' });
                else $this.$router.push({ name: 'home' });
            })
        },

        errorMessage(){
            // Error; SMS not sent
            this.$store.dispatch('sound/sfx','Error');
            this.$bvModal.msgBoxOk(this.$t('login.phone_verify_error_text'), {
                title: this.$t('login.phone_verify_error_title'),
                size: 'sm',
                buttonSize: 'lg',
                okTitle: this.$t('base.btn_ok'),
                modalClass: 'confirmModal',
                hideHeaderClose: false,
                centered: true
            })
            .then(value => {
                this.$store.dispatch('sound/sfx','Button');
            });
        },

        renderCaptcha() {
            if(this.recaptcha !== false) return;
            const $this = this;
            this.recaptcha = grecaptcha.render("recaptchaContainer", {
                sitekey: "6LdTntoZAAAAAAa6JvxclCkoTrXtqn_rhNyzHvUS",
                size: "invisible",
                badge: "bottomright",
                callback: (token) => {
                    $this.smsOtpLogin(token);
                    grecaptcha.reset(this.recaptcha);
                },
            });
        },

        executeCaptcha() {
            if (typeof grecaptcha !== "undefined" && grecaptcha.render)
                grecaptcha.execute(this.recaptcha);
            else console.error("Captcha not found");
        },

    },
}
</script>